import { render, staticRenderFns } from "./AtaTipoEdit.vue?vue&type=template&id=a591df52"
import script from "./AtaTipoEdit.vue?vue&type=script&lang=js"
export * from "./AtaTipoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports